import get from 'lodash/get';
import { type DataRequest, type ISortsDefinition, type PaginationDetails } from '../interfaces';
import moment from 'moment';

export const getObjectComparators = <V>(objA: V, objB: V, fieldName: keyof V) => { 
    let A = get(objA, fieldName);
    let B = get(objB, fieldName);
    if (A instanceof Date || (typeof A === 'string' && moment(A).isValid())) { A = moment(A).valueOf() }
    if (B instanceof Date || (typeof B === 'string' && moment(B).isValid())) { B = moment(B).valueOf() }
    if (typeof A === 'string') { A = A.toLocaleLowerCase() }
    if (typeof B === 'string') { B = B.toLocaleLowerCase() }
    return [ A, B ];
};

export const sortData: <T>(data: T[] | undefined, sorts: ISortsDefinition<T>) => T[] | undefined = (data, sorts) => {
    if (!data) {
        return undefined;
    }

    let sortedData = data.slice();
    if (sortedData.length > 0) {
        for (const field in sorts) {
            if (sorts[field]) {
                const dir = sorts[field];
                sortedData = (dir === 'asc')
                    ? sortedData.sort((itemA, itemB) => {
                        const [ A, B ] = getObjectComparators(itemA, itemB, field);
                        if (A === B) return 0;
                        return A >= B ? 1 : -1;
                    })
                    : sortedData.sort((itemA, itemB) => {
                        const [ A, B ] = getObjectComparators(itemA, itemB, field);
                        if (A === B) return 0;
                        return A < B ? 1 : -1;
                    })
            }
        }
    }
    
    return sortedData;
}

export const derivePaginationDetails = (total: number | undefined, dataRequest: DataRequest): PaginationDetails => {
    const pagesCount = Math.ceil((total || 1) / dataRequest.take);
    const currentPage = (dataRequest.skip / dataRequest.take) + 1;
    const currentRangeStart = dataRequest.skip + (total ? 1 : 0);
    const currentRangeEnd = Math.min(dataRequest.skip + dataRequest.take, total || 0);

    return {
        pagesCount,
        currentPage,
        currentRangeStart,
        currentRangeEnd,
        total,
        pageSize: dataRequest.take
    }
}